/**
 * BundleSection - Section affichant les bundles/packs sur la page d'accueil
 */
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Package, ChevronRight, Loader2 } from 'lucide-react';
import { BundleCard } from './BundleCard';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export function BundleSection() {
  const { t } = useTranslation();
  const [bundles, setBundles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBundles = async () => {
      try {
        const res = await axios.get(`${API_URL}/api/promotions/bundles`);
        // Filtrer les bundles actifs
        const activeBundles = (res.data.bundles || []).filter(b => b.is_active);
        setBundles(activeBundles);
      } catch (err) {
        console.error('Error fetching bundles:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchBundles();
  }, []);

  // Ne rien afficher s'il n'y a pas de bundles
  if (!loading && bundles.length === 0) {
    return null;
  }

  return (
    <section className="px-4 md:px-0" data-testid="bundles-section">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-purple-600/20 rounded-lg">
            <Package className="w-6 h-6 text-purple-500" />
          </div>
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-white">
              {t('home.sections.bundles', 'Packs & Offres')}
            </h2>
            <p className="text-sm text-gray-400">
              {t('home.sections.bundlesSubtitle', 'Économisez avec nos packs exclusifs')}
            </p>
          </div>
        </div>
        
        {bundles.length > 3 && (
          <Link 
            to="/bundles" 
            className="flex items-center gap-1 text-purple-400 hover:text-purple-300 transition-colors"
          >
            <span className="hidden sm:inline">{t('common.seeAll', 'Voir tout')}</span>
            <ChevronRight className="w-5 h-5" />
          </Link>
        )}
      </div>

      {/* Content */}
      {loading ? (
        <div className="flex items-center justify-center py-12">
          <Loader2 className="w-8 h-8 animate-spin text-purple-500" />
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {bundles.slice(0, 3).map((bundle) => (
            <BundleCard key={bundle.id} bundle={bundle} />
          ))}
        </div>
      )}
    </section>
  );
}

export default BundleSection;
